// upsell JS

function upsellSwiper(){
  new Swiper('.upsell-swiper', {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      }
    }
  });
}

$(document).ready(function () {
  $(document).on("click",".add_cart",function() {
    var variantId = $(this).siblings(".gift_variant_selector").val();

    if (!variantId) {
      alert("Selecteer een variant.");
      return;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: variantId
      },
      dataType: "json",
      success: function () {
        if (theme && typeof theme.CartDrawer === "function") {
          new theme.CartDrawer();
        } else {
          $("cart-drawer.drawer").load(location.href + " div#CartDrawer");
        }
      },
      error: function (err) {
        console.error("Error adding upsell item:", err);
      }
    });
  });
});


// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll(".show-more-swatches").forEach(function (btn) {
//     btn.addEventListener("click", function () {
//       let parent = btn.closest(".product_color_swatch");
//       parent.querySelectorAll(".hidden-swatch").forEach(function (swatch) {
//         swatch.style.display = "block";
//       });
//       btn.style.display = "none";
//     });
//   });
// });

// swatch JS

document.addEventListener("DOMContentLoaded", function () {
document.addEventListener("click", function (e) {
  const swatch = e.target.closest(".product_color_swatch_item");
  if (!swatch) return;

  e.preventDefault();

  const group = swatch.closest(".product_color_swatch");
  if (!group) return;

  group.querySelectorAll(".product_color_swatch_item").forEach(function (s) {
    s.classList.remove("active");
  });

  swatch.classList.add("active");
});

});

// Slide Js

$(document).on("click", ".product_color_swatch_item", function (e) {
e.preventDefault();

const $swatch = $(this);
const variantId = $swatch.attr("variant_id");
const variantURL = $swatch.attr("data-varaint-url");

$swatch.parents('.swatch_or_title').find('a.grid-product__link').attr('href', variantURL)
$swatch.parents('.swatch_or_title').find('.show-more-swatches')?.attr('href', variantURL)


const $productCard = $swatch.closest(".grid__item-image-wrapper");
if ($productCard.length === 0) return;

const $imagesWrapper = $productCard.find(".card____images____wrapper");
const $images = $imagesWrapper.find(".grid__image-var");
if ($imagesWrapper.length === 0 || $images.length === 0) return;

$productCard.find(".product_color_swatch_item").removeClass("active");
$swatch.addClass("active");

const $targetImage = $images.filter(`[variant_id='${variantId}']`);
if ($targetImage.length) {
  $images.removeClass("active");
  $targetImage.addClass("active");

  const scrollLeft = $targetImage[0].offsetLeft - $imagesWrapper[0].offsetLeft;

  $imagesWrapper.animate(
    { scrollLeft: scrollLeft },
    400
  );
}
});


// sticky add to cart btn
const stickyBtnWrapper = document.querySelector('.sticky-add-to-cart-wrapper');
const addToCart = document.querySelector('.add-to-cart');

if (stickyBtnWrapper && addToCart) {

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      console.log("working");
      stickyBtnWrapper.style.transform = 'translate(0, 100%)';
      stickyBtnWrapper.classList.remove('active');
    } else {
      console.log("not working");
      stickyBtnWrapper.style.transform = 'translate(0, 0)';
      stickyBtnWrapper.classList.add('active');
    }
  });
}, {
  threshold: 0.1
});

observer.observe(addToCart);
}

// sticky add to cart btn scroll
$('#sticky-add-to-cart-btn').click(function () {
  // Try to find the first target
  var targetElement = $('.kaching-bundles__bars');

  // If the first target doesn't exist, try the fallback
  if (targetElement.length === 0) {
      targetElement = $('.variant-wrapper');
  }

  // If either of the elements is found, scroll to it
  if (targetElement.length > 0) {
      var targetOffset = targetElement.offset().top;
      var scrollOffset = 150; // Adjust this value as needed (100-200 works well)

      $('html, body').animate({
          scrollTop: targetOffset - scrollOffset
      }, 600);
  }
});


